import { Controller } from "stimulus"
import Slideout from "slideout/dist/slideout.min.js"
import Velocity from "velocity-animate"
import SmoothScroll from "smooth-scroll/dist/smooth-scroll.min.js"

export default class extends Controller {
  static targets = [ "subnav" ]

  connect() {
    //// Slideout
    window.slideout = new Slideout({
      'panel': document.querySelector('.page'),
      'menu': document.querySelector('.offset'),
      'padding': 256,
      'ease': 'ease-in-out',
      'side': 'right',
      'touch': false
    })

    // Slideout overlay
    function close(eve) {
      eve.preventDefault()
      window.slideout.close()
    }

    window.slideout
      .on('beforeopen', function() {
        this.panel.classList.add('page-open');
      })
      .on('open', function() {
        this.panel.addEventListener('click', close);
      })
      .on('beforeclose', function() {
        this.panel.classList.remove('page-open');
        this.panel.removeEventListener('click', close);
      })

    document.querySelector('.navbar-burger').addEventListener('click', function() {
      window.slideout.toggle();
    })

    // Turbolinks fix
    document.addEventListener('turbolinks:load', function() {
      document.querySelector('html').classList.remove('slideout-open')
    })

    var offset_items = document.querySelectorAll(".offset-menu > .offset-item.is-parent > a");

    function toggle_offset_item(eve) {
      var item = eve.target.closest('.offset-item')
      var nodes = item.querySelector('.offset-nodes')

      if (item.classList.contains('is-active')) {
        var slideDir = 'slideUp'
        item.classList.remove("is-active")
      } else {
        var slideDir = 'slideDown'
        item.classList.add("is-active")
      }

      Velocity(nodes, slideDir, {duration: 200, easing: 'ease-in-out' })

      eve.preventDefault()
    }

    for (var i = 0; i < offset_items.length; i++) {
      offset_items[i].addEventListener('click', toggle_offset_item, false)
    }
    //// Slideout END

    //// Smooth Scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
      ignore: '.header a, .offset a',
      topOnEmptyHash: false
    })
    //// Smooth Scrolling END

    // Prevent turbolinks to reload the page when hitting on an anchor link in header nav
    var parent_links = document.querySelectorAll('.navbar-menu .is-parent a[href="#"]')
    parent_links.forEach(function(link) {
      link.addEventListener('click', function(event) {
        event.preventDefault()
      })
    })
  }

  toggle_subnav() {
    var subnav = this.subnavTarget
    var menu = subnav.querySelector('.subnav-menu')
    if (subnav.classList.contains('is-active')) {
      var slideDir = 'slideUp'
      subnav.classList.remove('is-active')
    } else {
      var slideDir = 'slideDown'
      subnav.classList.add('is-active')
    }

    Velocity(menu, slideDir, {duration: 200, easing: 'ease-in-out' })

    event.preventDefault()
  }
}
